import {Switch,Route} from 'react-router-dom'
import Layout1 from '../layouts/backend/layout1'
import BlankLayout from '../layouts/blanklayout';

import BlankDashboardLayout from '../layouts/backend/dashboard';

import PaymentLayout from '../layouts/PaymentLayout';

const LayoutsRoute = props => {
    return (
        <Switch>
            <Route path="/extra-pages" component={BlankLayout} />
            <Route path="/auth" component={BlankLayout} />
            <Route path="/manager" component={BlankDashboardLayout} />
            <Route path="/signature" component={PaymentLayout} />
            <Route path="/" component={Layout1} />
        </Switch>
    )
}

export default LayoutsRoute